// 过滤格式，将格式生成成符合集联选择器的格式
export function generatePairs(original, options) {
  const result = [];

  (original.salary_type ?? []).forEach((parent) => {
    const parentObj = options.find((r) => r.value === parent);

    if (parentObj && parentObj.children) {
      (original.salary ?? []).forEach((child) => {
        const childValue = parentObj.children.find((c) => c.value === child);

        if (childValue) {
          result.push([parent, child]);
        }
      });
    }
  });

  return result;
}

// 还原入参格式
export function restoreOriginalObject(pairs) {
  const originalObject = {
    salary_type: [],
    salary: []
  };

  pairs.forEach((pair) => {
    const [region, location] = pair;

    if (!originalObject.salary_type.includes(region)) {
      originalObject.salary_type.push(region);
    }

    originalObject.salary.push(location);
  });

  return originalObject;
}

export const formatSalary = (salaryTypeLists = []) => {
  return salaryTypeLists
    .filter((v) => Boolean(v.salary_range_list))
    .map((obj, index) => {
      const firstParent = {
        label: obj.salary_type,
        id: index,
        value: obj.seo_value,
        salary_type_id: obj.salary_type_id,
        children: undefined
      };
      firstParent.children = (obj?.salary_range_list ?? []).map((second) => {
        const secondParent = {
          id: second.id,
          label: second.value,
          value: second.seo_value
        };
        return secondParent;
      });
      return firstParent;
    });
};

export function getOneLabel(options, seoValue) {
  return options.reduce((acc, option) => {
    const found = option.children.find((item) => item.value === seoValue);
    return found ? found.label : acc;
  }, null);
}